const translations = {
  "en": {
    "Alpha canceled due to impatience. Found a spicier question?": "Alpha canceled due to impatience. Found a spicier question?",
    "Brewing your report ☕  This may take a few minutes - Page departure would abort mission": "Brewing your report ☕  This may take a few minutes - Page departure would abort mission",
    "Data Acquired on:": "Data Acquired on:",
    "Got it — I've got a good read on you. Let me look a little closer": "Got it — I've got a good read on you. Let me look a little closer"
  },
  "zh-tw": {
    "Alpha canceled due to impatience. Found a spicier question?": "Alpha 因等待超時已取消。換個更勁爆的問題試試？",
    "Brewing your report ☕  This may take a few minutes - Page departure would abort mission": "正在為你沖泡報告 ☕ 這可能需要幾分鐘 — 離開頁面將中止任務",
    "Data Acquired on:": "資料取得時間：",
    "Got it — I've got a good read on you. Let me look a little closer": "好，我大概摸清你的樣子了。讓我再看仔細一點。"
  }
};

export default translations;
